export enum StatusApproval {

    PendingApproval = 1,
    PendingPayment = 2,
    Paid = 3,
    AwaitingRational = 4,
    PendingRegularizationCompany = 5
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusApproval.ts